export default __webpack_public_path__ + "static/media/9f66f8ebfbb34bc37509bf4f6a1f7cc7.svg";